import React from 'react';
import { ExternalLink } from 'lucide-react';
import styled from 'styled-components';
import { adsEnabled } from '../../utils/adsEnabled';

const Card = styled.a`
  display: block;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.card};
  box-shadow: ${({ theme }) => theme.shadowCard};
  border-left: 4px solid ${({ theme }) => theme.colors.gold};
  padding: 1.25rem;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`;

const AdTag = styled.span`
  padding: 0.125rem 0.5rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: rgba(220, 38, 38, 0.1);
  color: ${({ theme }) => theme.colors.crimson};
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const Sponsor = styled.span`
  font-size: 0.625rem;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

const Title = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.foreground};
`;

const Desc = styled.p`
  margin: 0.375rem 0 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
  line-height: 1.5;
`;

const Cta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
`;

/** Text-only promo card (matches crimson-compass AdCard — no image in layout). */
function AdCard({ ad }) {
  if (!adsEnabled()) return null;

  return (
    <Card href={ad.url} target="_blank" rel="noopener noreferrer sponsored">
      <Row>
        <AdTag>Ad</AdTag>
        <Sponsor>{ad.sponsor}</Sponsor>
      </Row>
      <Title>{ad.title}</Title>
      <Desc>{ad.description}</Desc>
      <Cta>
        {ad.cta} <ExternalLink size={12} />
      </Cta>
    </Card>
  );
}

export default AdCard;
